import type { InvoiceStatus as InvoiceStatusType } from '@cocoonspace/sdk-js/types/invoiceStatus'
import { cn } from '@cocoonspace/ui/lib/utils'
import { Trans } from '@lingui/react/macro'
import {
	CheckIcon,
	HourglassIcon,
	TriangleAlertIcon,
	XIcon,
} from 'lucide-react'

export const InvoiceStatus = ({
	status,
	className,
}: {
	status: InvoiceStatusType
	className?: string
}) => (
	<div
		className={cn(
			'flex items-end gap-x-1 leading-none lg:items-center lg:gap-x-2 lg:px-4',
			className,
		)}
	>
		{status === 'late' && <HourglassIcon className='text-primary' />}

		{status === 'open' && <TriangleAlertIcon className='text-warning' />}

		{status === 'late' && <Trans>En retard</Trans>}
		{status === 'open' && <Trans>À payer</Trans>}

		{status === 'paid' && (
			<>
				<CheckIcon className='text-emerald-400' />
				<Trans>Payée</Trans>
			</>
		)}

		{status === 'voided' && (
			<>
				<XIcon className='text-primary' />
				<Trans>Annulée</Trans>
			</>
		)}
	</div>
)
